<template>
  <div>
    <!-- begin breadcrumb -->
    <ol class="breadcrumb pull-right">
      <li class="breadcrumb-item active">
        <a href="javascript:;">修改密码</a>
      </li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">修改密码</h1>
    <!-- end page-header -->
    <panel title="修改密码">
      <div class="row">
        <div class="col-md-4"></div>
        <div class="col-md-4">
          <Card>
            <p slot="title">系统密码修改</p>
            <Form ref="formCustom" :model="formCustom" :rules="ruleCustom" :label-width="80">
              <FormItem label="旧密码" prop="oldpasswd">
                <Input type="password" v-model="formCustom.oldpasswd"></Input>
              </FormItem>
              <FormItem label="新密码" prop="passwd">
                <Input type="password" v-model="formCustom.passwd"></Input>
              </FormItem>
              <FormItem label="再次输入" prop="passwdCheck">
                <Input type="password" v-model="formCustom.passwdCheck"></Input>
              </FormItem>

              <FormItem>
                <Button type="primary" @click="handleSubmit('formCustom')">提交保存</Button>
                <Button @click="handleReset('formCustom')" style="margin-left: 8px">重置</Button>
              </FormItem>
            </Form>
          </Card>
        </div>
      </div>
    </panel>
  </div>
</template>
<script>
import { updatePasswd } from "@/api/user";
export default {
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入新的的密码"));
      } else {
        if (this.formCustom.passwdCheck !== "") {
          // 对第二个密码框单独验证
          this.$refs.formCustom.validateField("passwdCheck");
        }
        callback();
      }
    };
    const validatePassCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入您的密码"));
      } else if (value !== this.formCustom.passwd) {
        callback(new Error("两次输入的密码不一致!"));
      } else {
        callback();
      }
    };
    const validatePass1 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入新的的密码"));
      } else {
        if (this.formEmailPasswd.passwdCheck1 !== "") {
          // 对第二个密码框单独验证
          this.$refs.formEmailPasswd.validateField("passwdCheck1");
        }
        callback();
      }
    };
    const validatePassCheck1 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入您的密码"));
      } else if (value !== this.formEmailPasswd.passwd1) {
        console.log(value, this.formEmailPasswd.passwd1);
        callback(new Error("邮箱密码两次输入不一致!"));
      } else {
        callback();
      }
    };
    const validateAge = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("密码不能为空"));
      }
      callback();
    };
    return {
      formCustom: {
        oldpasswd: "",
        passwd: "",
        passwdCheck: ""
      },
      ruleCustom: {
        passwd: [{ validator: validatePass, trigger: "blur" }],
        passwdCheck: [{ validator: validatePassCheck, trigger: "blur" }],
        passwd1: [{ validator: validatePass1, trigger: "blur" }],
        passwdCheck1: [{ validator: validatePassCheck1, trigger: "blur" }],
        oldpasswd: [{ validator: validateAge, trigger: "blur" }]
      }
    };
  },
  methods: {
    handleSubmit(name) {
      this.$refs.formCustom.validate(valid => {
        if (valid) {
          updatePasswd(
            this.formCustom.oldpasswd,
            this.formCustom.passwd,
            "account"
          )
            .then(res => {
              if (res.data.code == 200) {
                this.$Notice.success({
                  title: "成功",
                  desc: res.data.message
                });
              } else {
                this.$Notice.error({
                  title: "错误",
                  desc: res.data.message
                });
              }
            })
            .catch(error => {
              this.$Message.error(error);
            });
        }
      });
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    }
  }
};
</script>